module.exports = __webpack_public_path__ + "img/cloudy.a4e35ada.svg";